import { calcResize } from 'components/Layout/styles';
import styled from 'styled-components';

export const SDate = styled.span`
  color: grey;
`;

export const SPostContent = styled.article``;

export const SSection = styled.section`
  margin-top: 100px;
`;

export const STitle = styled.h1`
  font-size: ${calcResize(28, 48)};
  margin-bottom: 3rem;
`;
